<template>
  <div class="card-form">
    <PageTable
      ref="table"
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(e) => $emit('checkbox-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="preOrderDetailChooseList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import PageHeader from './header.vue'
import PageTable from './table.vue'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader, SortFieldsPopover },
  props: { hxPreOrderCode: { type: String, default: '' } },
  data() {
    return { usePage: true, sortFields: [] }
  },
  methods: {
    getData(form) {
      if (!this.hxPreOrderCode) return
      this.loading = true
      const params = {
        ...form,
        ...this.page,
        hxPreOrderCode: this.hxPreOrderCode,
        sortFields: this.sortFields,
      }
      this.$api
        .ecomHxPreOrderDetailOptionsApi(params)
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
    },
  },
}
</script>
